import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { REVEAL_PROTOTYPE } from './reveal-prototype';

@Component({
    selector: 'app-reveal',
    styleUrls: ['./reveal.component.scss'],
    templateUrl: './reveal.component.html',
    standalone: false
})
export class RevealComponent implements OnInit, AfterViewInit {

  private static ID = 0;

  @Input() public title: string;
  public id: number;
  private reveal: (el: any) => void = function(el) {
    this.root = el;
    this.header = el.querySelector('[data-js-reveal-header]');
    this.triggers = el.querySelectorAll('[data-js-reveal-trigger]');
    this.container = el.querySelector('[data-js-reveal-container]');
    this.isExpanded = this.triggers[0].getAttribute('aria-expanded') === 'true';
    this.registerEvents();
  };

  constructor() {
    this.id = RevealComponent.ID++;
  }

  public ngOnInit() {
    this.reveal.prototype = REVEAL_PROTOTYPE;
  }

  public ngAfterViewInit(): void {
    const component = document.querySelector(`[id=reveal-${this.id}][data-js-reveal]`);
    const reveal = new this.reveal(component);
  }
}
